export default __webpack_public_path__ + "static/media/naam.c9d38df1.jpg";